import styled from '@emotion/styled'
import { Translation, Locale } from 'locale'
import React from 'react'
import { AllocationData, CollateralBasketAllocationFieldNames } from './collateralBasketAllocationUploadParse'
import { ValidationPanelColDef, PendingValidationPanel } from '../upload/pendingValidationPanel'
import { SpreadsheetParseUploadAsideWrapper } from '../upload/SpreadsheetParseDialogStyles'
import { CollateralAllocationValidationResult } from './collateralBasketAllocationUploadValidator'

const collateralBasketAllocationValidationPanelColumnDefinitions: ValidationPanelColDef<AllocationData>[] = [
  {
    headerLabel: Translation.TC_ISIN,
    getter: allocation => allocation.isin,
    fieldName: CollateralBasketAllocationFieldNames.isin
  },
  {
    headerLabel: Translation.TC_NOTIONAL_SHORT,
    getter: allocation => allocation.notional,
    fieldName: CollateralBasketAllocationFieldNames.notional,
    formatter: Locale.formatNumber,
    style: { textAlign: 'right' }
  },
  {
    headerLabel: Translation.TC_START_CONSIDERATION,
    getter: allocation => allocation.startConsideration,
    fieldName: CollateralBasketAllocationFieldNames.startConsideration,
    formatter: Locale.formatNumber,
    style: { textAlign: 'right' }
  },
  {
    headerLabel: Translation.TC_ALL_IN_PRICE,
    getter: allocation => allocation.allInPrice,
    fieldName: CollateralBasketAllocationFieldNames.allInPrice,
    formatter: Locale.formatNumber,
    style: { textAlign: 'right' }
  },
  {
    headerLabel: Translation.TC_HAIRCUT,
    getter: allocation => allocation.haircut,
    fieldName: CollateralBasketAllocationFieldNames.haircut,
    formatter: v => Locale.formatNumber(v, { percent: true, decimalShift: 2 }),
    style: { textAlign: 'right' }
  }
]

export const CollateralBasketAllocationValidationPanelWrapper = styled(SpreadsheetParseUploadAsideWrapper)`
  min-width: 500px;
  height: 300px;
`
export const CollateralBasketAllocationValidationPanel: React.FC<{ validationResults: CollateralAllocationValidationResult[] }> = ({
  validationResults
}) => (
  <CollateralBasketAllocationValidationPanelWrapper>
    <PendingValidationPanel
      getRowId={r => r._id}
      panelHeading={Locale.translate(Translation.TC_ALLOCATION_UPLOAD_PENDING)}
      columnDefinitions={collateralBasketAllocationValidationPanelColumnDefinitions}
      validationResults={validationResults}
    />
  </CollateralBasketAllocationValidationPanelWrapper>
)
